<template>
  <div class="hive-list">
    <template v-if="isPageLoading">
      <page-loader :size="'w-10 h-10'" :height="200" class="mt-8" />
    </template>

    <template v-else-if="!isPageLoading && !isHaveApiary">
      <div class="text-center hive-list__not_apiary">
        <div class="apiary-image"></div>
        <div class="mt-3">
          <span class="mb-2">{{ $t("hives.NoApiary") }}</span>
          <br />
          <span>{{ $t("hives.AddApiaryMessage") }}</span>
        </div>
        <div class="mt-4 text-center flex items-center justify-center">
          <vs-button
            class="text-white"
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click="$router.push('/apiaries/new').catch(() => {})"
            >{{ $t("apiaries.AddNewApiary") }}</vs-button
          >
        </div>
      </div>
    </template>
    <template v-else-if="!isPageLoading && !isHaveHive">
      <div class="text-center hive-list__not_hive">
        <div class="hive-image"></div>
        <div class="mt-4 text-center flex items-center justify-center">
          <vs-button
            class="text-white"
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click="$router.push('/hives/new').catch(() => {})"
            >{{ $t("hives.CreateNewHive") }}</vs-button
          >
        </div>
      </div>
    </template>
    <template v-else-if="!isPageLoading && isHaveHive && isHaveApiary">
      <div class="vx-row hive-list__header">
        <div class="vx-col w-full  block md:flex hive-list__header_buttons" 
          :class="userRole !== 'user' ? 'md:w-full lg:w-7/12 xl:w-7/12' : 'md:w-3/4 lg:w-2/3  xl:w-3/4'">
          <div class="flex w-full md:w-auto hive-list__header_action_buttons">
            <vs-button
              v-if="isUserHaveApiary===true && isUserHaveHive===true "
              class="text-white mb-6 md:mb-base mr-3"
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click="$router.push('/hives/new').catch(() => {})"
              >
              <span class="md:inline-flex hidden">{{ $t("hives.CreateNewHive") }}</span>
              <span class="md:hidden inline-flex">{{ $t("hives.CreateHive") }}</span>
            </vs-button>
            <vs-button
              class="text-white mb-6 md:mb-base md:mr-3"
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click="$router.push('/devices/new').catch(() => {})"
              >
              <span class="md:inline-flex hidden">{{ $t("hives.AddDevice") }}</span>
              <span class="md:hidden inline-flex">{{ $t("hives.detail.AddDevice") }}</span>
            </vs-button>
          </div>
          <vs-button
            class="text-white mb-6 md:mb-base w-full md:w-auto"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-clipboard"
            @click="$router.push('/hives/notes').catch(() => {})"
            >{{ $t("hivenote.PageButton") }}
          </vs-button>
        </div>
         <div class="vx-col w-full  hive-list__header_filters" 
          :class="userRole !== 'user' ? 'md:w-full lg:w-5/12  xl:w-5/12' : 'md:w-1/4 lg:w-1/3  xl:w-1/4'">
         <Filters :apiaryData="apiaryData"/>
        </div>
      </div>
      <div class="mb-base" v-if="isUserHaveHive==false || isUserHaveApiary==false">
        <vx-card>
          <template v-if="isUserHaveApiary==false">
            <div class="text-center">
              {{ $t("hives.UserNotApiaryMessage") }}
              <div class="mt-4 text-center flex items-center justify-center">
                <vs-button
                  class="text-white"
                  color="warning"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push('/apiaries/new').catch(() => {})"
                  >{{ $t("apiaries.AddApiary") }}</vs-button
                >
              </div>
            </div>
          </template>
          <template v-if="isUserHaveApiary==true && isUserHaveHive==false">
            <div class="text-center">
              {{ $t("hives.UserNotHiveMessage") }}
              <div class="mt-4 text-center flex items-center justify-center">
                <vs-button
                  class="text-white"
                  color="warning"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push('/hives/new').catch(() => {})"
                  >{{ $t("hives.CreateNewHive") }}</vs-button
                >
              </div>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="vx-row hive-list-card">
        <template v-if="isFilterLoading">
          <page-loader :size="'w-10 h-10'" :height="200" class="mt-8" />
        </template>
        <template v-if="isFilterLoading==false && isHaveFileterDatas==false">
          <div class="flex items-center justify-center mt-10 w-full">
            <div class="mt-10 text-center">
              <div class="text-center pt-8 pb-3">
                <feather-icon
                  icon="AlertCircleIcon"
                  class="text-secondary"
                  svgClasses="w-8 h-8 stroke-current"
                />
                <div class="mt-1 h5">{{ hiveFilters.user!==null ? $t("hives.FiltersMsg") : $t("hives.ApiaryFiltersMsg") }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="isFilterLoading==false">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3  xl:w-1/4 mb-base" v-for="(data, index) in hives"
          :key="index">
          <template v-if="data.device">
            <template v-if="data.device.version=='V1'"><HiveCardV1 :hive="data"/></template>
            <template v-else><HiveCardV2 :hive="data"/></template>
          </template>
          <template v-else><HiveCardNoDevice :hive="data" /></template>
        </div>
        <div
          class="flex items-center justify-center w-full my-8"
          v-if="isLazyLoadLoading == true"
        >
          <div>
            <feather-icon
              icon="LoaderIcon"
              class="mr-3 bx-spin text-warning"
              svgClasses="w-10 h-10"
            ></feather-icon>
          </div>
        </div>

        <infinite-loading @infinite="infiniteHandler">
          <div slot="spinner"></div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        </template>
     
      </div>
    </template>
  </div>
</template>

<script>
import PageLoader from '../../components/Loader.vue'
import Filters from './components/filters.vue'
import HiveCardV1 from './components/hive-card-v1.vue'
import HiveCardV2 from './components/hive-card-v2.vue'
import HiveCardNoDevice from './components/hive-card-no-device.vue'
import InfiniteLoading from 'vue-infinite-loading'
import i18n from './../../i18n/i18n.js'
export default {
  components: { PageLoader, Filters, HiveCardV1, HiveCardV2, HiveCardNoDevice, InfiniteLoading },
  data () {
    return {
      isPageLoading: true,
      isFilterLoading: false,
      isHaveApiary: true,
      isHaveHive: true,
      isHaveFileterDatas: true,
      isUserHaveApiary: true,
      isUserHaveHive: true,
      apiaryData:{},
      hives:[],
      cursor:null,
      isLazyLoadLoading:false,
      lastData:null
    }
  },
  computed: {
    hivesData () {
      return this.$store.getters.returnHivesData
    },
    userRole () {
      return this.$store.getters.userRole
    },
    hiveFilters () {
      return this.$store.getters.hiveFilters
    }
  },
  watch:{
    hiveFilters:{
      handler (n, o) {
        if (o) {
          this.isFilterLoading = true
          this.hives = []
          clearInterval(this.lastData)
          if (n.apiary === null && n.user === null) {
            this.isHaveFileterDatas = true
            this.getHivesData('', 'filter')
          } else {
            let params = ''

            if (n.user !== null) {
              params += params === ''
                ? `?user=${  n.user}`
                : `&user=${  n.user}`
            }

            if (n.apiary !== null) {
              params += params === ''
                ? `?apiary=${  n.apiary}`
                : `&apiary=${  n.apiary}`
            }
           
            this.getHivesData(params, 'filter')
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    clearInterval(this.lastData)
  },
  mounted () {
    this.getApiaries('')
    this.$store.dispatch('addNewDeviceData', null).catch(() => {})
  },
  methods:{
    getApiaries (params) {
      this.$store
        .dispatch('getApiariesData', params)
        .then((response) => {
          this.apiaryData = response.data

          if (response.data.my_apiaries_count>0) {
            this.isUserHaveApiary = true
          } else {
            this.isUserHaveApiary = false
          }

          if (response.data.results.length>0) {
            this.isHaveApiary = true
            this.getHivesData('', 'list')
          } else {
            this.isHaveApiary = false
            this.isPageLoading = false
          }
        })
        .catch((error) => {
          this.isPageLoading = false
          this.apiaryData = {}
          this.errorMsg(error)
        })
    },
    getHivesData (params, type) {
      const that = this
      this.cursor = null
      this.isLazyLoadLoading = false
      this.$store
        .dispatch('getHivesData', params)
        .then((response) => {
          this.hives = []
          if (type === 'list') {
            if (response.data.my_hives_count>0) {
              this.isUserHaveHive = true
            } else {
              this.isUserHaveHive = false
            }
          }


          if (response.data.results.length>0) {
            if (type === 'list') {
              this.isHaveHive = true 
            } else {
              this.isHaveFileterDatas = true
            }
            this.hives = this.hivesData.all
            this.lastData = setInterval(function () {
              that.$store.dispatch('getLastHiveDatas')
            }, 300000)
          } else if (response.data.results.length === 0) {
            if (type === 'list') {
              this.isHaveHive = false 
            } else {
              this.isHaveFileterDatas = false
            } 
          }

          this.cursor = response.data.next
          if (response.data.next === null) {
            this.isLazyLoadLoading = false
          } else {
            this.isLazyLoadLoading = true
          }

          this.isPageLoading = false
          this.isFilterLoading = false

        })
        .catch((error) => {
          this.hives = []
          this.isPageLoading = false
          this.isFilterLoading = false
          this.errorMsg(error)
        })
    },
    infiniteHandler ($state) {
      const that = this
      if (this.cursor !== null) {
        this.$store
          .dispatch('getHivesLazyLoadData', this.cursor)
          .then((response) => {
            clearInterval(this.lastData)
            if (response.data.results.length) {
              this.hives = this.hivesData.all
              this.lastData = setInterval(function () {
                that.$store.dispatch('getLastHiveDatas')
              }, 300000)
            }
            this.cursor = response.data.next
            if (response.data.next === null) {
              this.isLazyLoadLoading = false
              $state.complete()
            } else {
              this.isLazyLoadLoading = true
              $state.loaded()
            }
          })
          .catch((error) => {
            this.errorMsg(error)
          })
      }
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss">
.hive-list {
  .hive-list__not_hive {
    margin-top: 10%;
    img {
      margin: 0px auto;
      display: flex;
      margin-top: 15%;
      cursor: pointer;
    }
  }
  .hive-list__not_apiary {
    margin-top: 10%;
    img {
      margin: 0px auto;
      display: flex;
      cursor: pointer;
    }
  }
  @media (max-width: 576px) {
    .hive-list__not_apiary {
      margin-top: 5%;
      img {
        width: 210px;
      }
    }
    .hive-list__not_hive {
      margin-top: 5%;
      img {
        width: 180px;
      }
    }
  }

  .hive-list__header{
    .hive-list__header_buttons{
      @media (max-width: 767.98px) {
        button {
          width: 100% !important;
        } 
      }

      @media (min-width: 1200px) and (max-width: 1300px) {
        &.xl\:w-3\/4, &.xl\:w-7\/12 {
          width: 100% !important;
        }
      }
      @media (min-width: 991.97px) and (max-width: 1024px) {
        &.lg\:w-2\/3, &.lg\:w-7\/12 {
          width: 100% !important;
        }
      }
    }

    .hive-list__header_filters{
      @media (min-width: 1200px) and (max-width: 1300px) {
        &.xl\:w-1\/4, &.xl\:w-5\/12 {
          width: 100% !important;
        }
      }
      @media (min-width: 991.97px) and (max-width: 1024px) {
        &.lg\:w-1\/3, &.lg\:w-5\/12 {
          width: 100% !important;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1400px) {
    .hive-list-card{
      .xl\:w-1\/4 {
        width: 33.33333% !important;
      }
    }
  }

  .hive-list__header_action_buttons{
    @media (max-width: 400px) {
      display: block !important;
      button {
        margin-right: 0px !important;
      } 
    }
  }

  .apiary-image{
    margin:0px auto;
    width: 200px;
    height: 200px;
    background-image: url("../../assets/images/project/platform_apiary_image.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
  }

  .hive-image{
    margin:0px auto;
    width: 230px;
    height: 230px;
    background-image: url("../../assets/images/project/platform_hive_image.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
  }

}
</style>